/**
 * The body of the post-submit thank-you screen: the survey's own closing message when the admin
 * has written one, otherwise the default confirmation. Shared by the respondent screen and the
 * editor preview so the default wording stays in one place.
 */
export function CompletionMessage({ message }: { message?: string }) {
  return (
    <p className="completion-message">{message?.trim() || 'Your response has been recorded.'}</p>
  );
}
